<ion-content class="auth-layout">
  <div class="auth-container">
    <ion-router-outlet></ion-router-outlet>
  </div>
</ion-content>